"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_query_1 = require("react-query");
var format_price_1 = __importDefault(require("../../../../../utils/format-price"));
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
var error_message_1 = __importDefault(require("../../../components/error_message"));
var loading_modal_1 = __importDefault(require("../../../components/loading_modal"));
var save_button_1 = require("../../../components/save_button");
var add_discount_1 = require("../../../mutations/add-discount");
var remove_discount_1 = require("../../../mutations/remove-discount");
var renderDiscountValue = function (rechargeDiscount) {
    return rechargeDiscount.discount_type === 'fixed_amount' ? (0, format_price_1.default)(rechargeDiscount.value) : "".concat(rechargeDiscount.value, "%");
};
var renderDiscountCodeAndValue = function (rechargeDiscount, isDiaperFund, isGiftCode) {
    // Very simple frontend hiding of id.me discount codes. Until we find that people are inspecting their network traffic to retrieve their actual codes, this should be fine.
    var isMilitaryCode = rechargeDiscount.code.startsWith('MIL-');
    if (isMilitaryCode)
        return 'Military Discount Applied!';
    var isFirstResponderCode = rechargeDiscount.code.startsWith('FRSP-');
    if (isFirstResponderCode)
        return "First Responder's Discount Applied!";
    var isEducatorCode = rechargeDiscount.code.startsWith('EDU-');
    if (isEducatorCode)
        return "Educator's Discount Applied!";
    var isNurseCode = rechargeDiscount.code.startsWith('NUR-');
    if (isNurseCode)
        return "Nurse's Discount Applied!";
    return "".concat(rechargeDiscount.code, " (").concat(!!isDiaperFund || !!isGiftCode ? 'Balance: ' : '').concat(renderDiscountValue(rechargeDiscount)).concat(!isDiaperFund && !isGiftCode ? ' off' : '', ")");
};
var DiscountCode = function (_a) {
    var _b, _c;
    var groupedSubscription = _a.groupedSubscription, openDrawer = _a.openDrawer, setOpenDrawer = _a.setOpenDrawer, customer = _a.customer;
    var discount = (_b = groupedSubscription.address) === null || _b === void 0 ? void 0 : _b.discount;
    var discountCode = discount === null || discount === void 0 ? void 0 : discount.code;
    var addressId = (_c = groupedSubscription.address) === null || _c === void 0 ? void 0 : _c.id;
    var queryClient = (0, react_query_1.useQueryClient)();
    var _d = __read((0, react_1.useState)(false), 2), errorAddingDiscount = _d[0], setErrorAddingDiscount = _d[1];
    if (!addressId) {
        // addressId  is needed to do add/remove discounts. if we don't have one then return
        return react_1.default.createElement(react_1.default.Fragment, null, "Error");
    }
    var callout = (0, callout_1.useCallout)().callout;
    var _e = (0, react_query_1.useMutation)('RemoveDiscount', function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(remove_discount_1.REMOVE_DISCOUNT, variables); }, {
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // because of the async nature on recharge's end for removing discounts, the pricing might not reflect in our invalidated queries response until later
                        // so add messaging in callout that a refresh may be required
                        callout.success('Successfully Removed Discount! (Refresh page to reflect pricing changes)');
                        return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    }), removeDiscount = _e.mutateAsync, isRemovingDiscount = _e.isLoading;
    var _f = (0, react_query_1.useMutation)('AddDiscount', function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(add_discount_1.ADD_DISCOUNT, variables); }, {}), addDiscount = _f.mutateAsync, isAddingDiscount = _f.isLoading, isError = _f.isError;
    var _g = (0, react_hook_form_1.useForm)({
        mode: 'all',
        defaultValues: {
            code: discountCode,
        },
    }), register = _g.register, handleSubmit = _g.handleSubmit, errors = _g.errors;
    var onRemoveDiscountSubmit = handleSubmit(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, removeDiscount({
                        object: 'address',
                        objectId: addressId,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
    var onAddDiscountSubmit = handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var addedDiscount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, addDiscount({
                        object: 'address',
                        objectId: addressId,
                        discountCode: data.code,
                    })];
                case 1:
                    addedDiscount = _a.sent();
                    if (!addedDiscount.addDiscount) return [3 /*break*/, 3];
                    callout.success('Successfully Added Discount! (Refresh page to reflect pricing changes)');
                    // only refresh and invalidate cache if discount was successfully added
                    return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                case 2:
                    // only refresh and invalidate cache if discount was successfully added
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setErrorAddingDiscount(true);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); });
    var isDiaperFund = !!(discountCode === null || discountCode === void 0 ? void 0 : discountCode.startsWith('GFT-DB'));
    var isGiftCode = !!(discountCode === null || discountCode === void 0 ? void 0 : discountCode.startsWith('GFT-'));
    var inputField = !discountCode ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("label", null,
            react_1.default.createElement("input", { name: 'code', type: 'text', ref: register({
                    required: {
                        value: true,
                        message: 'Please enter a discount code',
                    },
                }) }),
            react_1.default.createElement("span", { className: 'placeholder' }, discountCode || '')),
        react_1.default.createElement(save_button_1.SaveButton, { onClick: onAddDiscountSubmit, isLoading: isAddingDiscount }),
        react_1.default.createElement(error_message_1.default, { error: errors.code }),
        errorAddingDiscount && !isAddingDiscount ? react_1.default.createElement(error_message_1.default, { error: { message: 'Invalid code entered' } }) : react_1.default.createElement(react_1.default.Fragment, null))) : (react_1.default.createElement("div", { className: 'padding-top-3' },
        react_1.default.createElement(save_button_1.SaveButton, { buttonText: 'Remove Discount', loadingButtonText: 'Removing Discount', onClick: onRemoveDiscountSubmit, isLoading: isRemovingDiscount })));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(loading_modal_1.default, { isLoading: isAddingDiscount, error: isError }),
        react_1.default.createElement("div", { className: 'horizontal-divider' }),
        react_1.default.createElement("a", { onClick: function () { return setOpenDrawer(openDrawer === 'discount_code' ? undefined : 'discount_code'); } },
            react_1.default.createElement("div", { className: 'account-subheader solid-border-top' },
                (function () {
                    if (isDiaperFund)
                        return 'Diaper Fund Code';
                    if (isGiftCode)
                        return 'Gift Card Code';
                    return 'Discount Code';
                })(),
                react_1.default.createElement("span", { className: "arrow ".concat(openDrawer === 'discount_code' ? 'up' : 'down') })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    !!discount ? renderDiscountCodeAndValue(discount, isDiaperFund, isGiftCode) : 'No Discount Code Applied',
                    isDiaperFund && (react_1.default.createElement(react_1.default.Fragment, null,
                        "\u00A0\u00A0",
                        react_1.default.createElement("a", { href: "https://www.fundmydiapers.com/?email=".concat(encodeURIComponent(customer.email)), target: '_blank', rel: 'noreferrer', className: 'link-wisteria' }, "Manage")))))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('account-drawer-content', { open: openDrawer === 'discount_code' }) }, inputField)));
};
exports.default = DiscountCode;
